import TicketDetailContainer from "./ticketDetail.container";

export default TicketDetailContainer;
